import { useEffect } from 'react';
import { useFormContext } from 'remix-validated-form';

export function DevErrorLog() {
	const { fieldErrors } = useFormContext();

	useEffect(() => {
		if (!!Object.keys(fieldErrors).length) {
			console.warn(fieldErrors);
		}
	}, [fieldErrors]);

	return null;
}
